import DapDSCombobox from './combobox.component'

export * from './combobox.component'
export default DapDSCombobox

DapDSCombobox.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-combobox': DapDSCombobox
  }
}
